import { useBlock, useSlate } from '@tribeplatform/react-slate-kit/hooks'
import type { BC } from '@tribeplatform/react-slate-kit/types'

import { PostCard } from './components/PostCard.js'
import type { SinglePostBlockProps } from './types.js'

export const SinglePostBlock: BC<SinglePostBlockProps> = ({
  postId,
  fields,
  postTypeId,
  postTypeSlug,
  ...rest
}) => {
  const {
    mode,
    context: { postId: slateContextPostId },
  } = useSlate()
  const {
    extraContext: { activeFieldId },
  } = useBlock<SinglePostBlockProps, { activeFieldId?: string }>()
  const preview = mode !== 'live'

  if (!postTypeId && !postTypeSlug) {
    return null
  }

  return (
    <PostCard
      postId={postId}
      fields={fields}
      postTypeId={postTypeId}
      postTypeSlug={postTypeSlug}
      activeFieldId={activeFieldId}
      isPostPage={!!slateContextPostId}
      preview={preview}
      {...rest}
    />
  )
}
